import script from "./OverviewCardNew.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewCardNew.vue?vue&type=script&setup=true&lang=js"

import "./OverviewCardNew.vue?vue&type=style&index=0&id=eaa15b24&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaa15b24"]])

export default __exports__